// extracted by mini-css-extract-plugin
export default {"heroContainer":"hero_heroContainer__JeaN+","h1":"hero_h1__0ts1B","overText":"hero_overText__vQ3GA","description":"hero_description__EwrvR"};